import React from 'react';
import { ComboBoxSlider, IComboBox } from '@sky-it-elections/design-system';

export const COMBO_BOX_SLIDER_TAG = 'ld-combo-box-slider-wrapper';

export interface IComboSliderWrapperProps {
  comboBoxArray: IComboBox[];
}

const ComboBoxSliderWrapper: React.FC<IComboSliderWrapperProps> = ({ comboBoxArray }) => {
  return <ComboBoxSlider comboBoxArray={comboBoxArray} />;
};

export default ComboBoxSliderWrapper;
